
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

// > legacy/validation <
import useValidationMessages from '@/common/composable/useValidationMessages'
import type { ErrorObject } from '@vuelidate/core'

export default defineComponent({
    props: {
        type: {
            type: String as PropType<'text' | 'password'>,
            default: 'text'
        },
        size: {
            type: String as PropType<'medium' | 'big'>,
            default: 'medium'
        },
        modelValue: {
            type: String,
            default: null
        },
        placeholder: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false,
        },
        invalid: {
            type: Boolean,
            default: false,
        },
        validationErrors: {
            type: Array as PropType<ErrorObject[]>,
            default: () => [],
        },
    },
    emits: ['update:modelValue', 'input', 'change'],
    setup(props, { emit }) {
        const { getValidationMessage } = useValidationMessages()

        const onInput = (event: Event) => {
            if (props.disabled) return

            const input = event.target as HTMLInputElement
            emit('update:modelValue', input.value)
            emit('input', event)
        }

        const onChange = (event: Event) => {
            if (props.disabled) return
            const input = event.target as HTMLInputElement
            emit('change', input.value)
        }

        return {
            onInput,
            onChange,
            getValidationMessage
        }
    }
})
